import { UserRoleModel } from "../models/UserRoleModel";
import Store from "./Store";
import { action, computed, observable, runInAction } from "mobx";
import { userService } from "../services/UserService";
import { RootStore } from "./RootStore";
import { UserRole } from "../enums/user-roles";
import { organizationService } from "../services/OrganizationService";
import { remove } from "lodash";
import { CommonUtils } from "../utils/CommonUtils";

export class UserRoleStore extends Store<UserRoleModel> {
  @observable isUsersLoading = false;
  @observable searchQuery = "";
  @observable isUsersLoaded = false;

  constructor(private rootStore: RootStore) {
    super();
    UserRoleModel._store = this;
  }

  @action
  setUserSearchQuery(query: string) {
    this.searchQuery = query;
  }

  @action
  async listUsers() {
    const orgId = this.rootStore.organizationRoleStore?.selectedOrganizationId!;

    if (this.isUsersLoading || this.isUsersLoaded) {
      return;
    }
    try {
      this.isUsersLoading = true;
      const data = await userService.getStaffUsersList(orgId);
      runInAction(() => {
        this.addAll(data);
        this.isUsersLoading = false;
        this.isUsersLoaded = true;
      });
    } catch (error) {
      runInAction(() => {
        this.isUsersLoading = false;
      });
    }
  }

  @action
  async assignRoleToUser(userId: string, permission: UserRole) {
    const orgId = this.rootStore.organizationRoleStore?.selectedOrganizationId!;
    const user = this.rootStore.userStore?.get(userId);

    const response = await organizationService.assignRole(orgId, {
      userId,
      role: permission,
    });

    // Delete previous role if one exists
    const userRole = this.entities.filter((e) => e.user.uid === userId)[0];
    if (userRole) {
      remove(this.entities, (e) => e.id === userRole.uid);
    }

    UserRoleModel.fromJson({
      ...userRole,
      ...response,
      id: response.uid,
      user,
    });
  }

  @computed
  get organizationUsersDetails(): UserRoleModel[] {
    return this.entities.filter((e) => {
      const name = CommonUtils.getUserDisplayDetail(e.user);
      return name.toLowerCase().indexOf(this.searchQuery.toLowerCase()) !== -1;
    });
  }

  @computed
  get displayStaffUsers(): UserRoleModel[] {
    return this.entities.filter((e) => {
      const name = CommonUtils.getUserDisplayDetail(e.user);
      return name.toLowerCase().indexOf(this.searchQuery.toLowerCase()) !== -1;
    });
  }
}
